export enum SectionsType {
  Relationships = 'relationships',
  SubmissionForm = 'submission-form',
  Upload = 'upload',
  License = 'license',
  CcLicense = 'cclicense',
  AccessesCondition = 'accessCondition',
  SherpaPolicies = 'sherpaPolicy',
  Identifiers = 'identifiers',
  Collection = 'collection',
  CoarNotify = 'coarnotify',
  Duplicates = 'duplicates'
}
